import { CavernsSubmodeKeyType } from 'dt-common/generated/types/enums';
import { CavernsDispatcher, CurrencyDispatcher } from '~/flux/dispatchers';
import mutationCavernsReturnToSurface from '~/graphql/caverns/mutationCavernsReturnToSurface';
import { logError } from '~/logger';
import messages from '../messages';

export default async function returnToSurface(
  { playerId, emit }: { playerId: string; emit: (message: string, data: any) => void; },
  { game_submode }: { game_submode: CavernsSubmodeKeyType; }
) {
  try {
    const data = await mutationCavernsReturnToSurface({
      playerId,
      game_submode,
    });

    data.currency2 !== undefined &&
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency2: data.currency2,
      });

    emit(messages.RETURNED_TO_SURFACE, data);

    CavernsDispatcher.handleCavernsAction({
      actionType: CavernsDispatcher.RETURNED_TO_SURFACE,
      ...data,
    });
  } catch (err) {
    logError(err, {
      module: 'CavernsStore',
      func: 'returnToSurface',
      playerId,
      game_submode,
    });
  }
}
